export enum PaypalTypesEnum {
  PAYPAL = 'paypal',
  PAYPAL4X = 'paypal4x',
  PAYPAL_AGREEMENT = 'paypal_agreement',
}

export enum FundingSources {
  PAY_LATER = 'paylater',
  PAYPAL = 'paypal',
}

export const PAYPAL_FUNDINGS = {
  [PaypalTypesEnum.PAYPAL]: FundingSources.PAYPAL,
  [PaypalTypesEnum.PAYPAL4X]: FundingSources.PAY_LATER,
  [PaypalTypesEnum.PAYPAL_AGREEMENT]: FundingSources.PAYPAL,
};
